import { MapConst } from "@ryde/shared";

import { TRAIL_POINT_DETOUR_RADIUS_PX } from "../route-block-maplibre.constants";
import { ITrailDotStyle } from "./maplibre-tracking-trail-points.models";

/** Fixed styling for a dot recorded off the planned route; only the plain dot varies, by route colour. */
export const DETOUR_DOT_STYLE: ITrailDotStyle = {
  color: MapConst.GPS_TRAIL_DETOUR_COLOR,
  strokeColor: MapConst.TRACKING_POINT_DETOUR_BORDER_COLOR,
  radiusPx: TRAIL_POINT_DETOUR_RADIUS_PX,
  strokeWidthPx: MapConst.TRACKING_POINT_DETOUR_BORDER_WEIGHT,
};
